import BuyingFilter from "../../components/filteration/buyingFilter";
import UserItemShop from "../../components/UserShopItem/UserItemShop";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import ShareModel from "../../components/Sharemodel";
import url from "../../config/axios";
import ShareOption from "../../components/Shareoption";
import BackArrow from "../../components/backArrow";
import { ShopContext } from "../../config/shopContext";
import { useGetShopCategoriesQuery, useLazyGetShopCategoriesQuery, useLazyGetFilteredSingleScrapItemQuery } from "../../features/shop/shopApiSlice";
import "./singleItemBuy.css";

const SingleItemBuy = () => {
  const shopType = "singleItem"; // Unique type for this page
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  const [dataCategory, setDataCategory] = useState(currentData?.dataCategory || {
    categoryid: "",
    subCategoryid: "",
  });

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];
  const subcategoryName = dataCategory?.subCategoryid?.[1];
  const subcategoryitwo = dataCategory?.subCategoryid?.[0];

  const [additionalShopCategoryData, setAdditionalShopCategoryData] = useState(currentData?.additionalData || {
    isShop: false,
    itemname: "",
    categoryid: "",
    subCategoryid: "",
    shopCategory: "",
    country: "",
    state: "",
    city: "",
    sale: "",
    salespromotion: "",
    min: "",
    max: "",
  });

  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [shopdata, setShopdata] = useState(currentData?.shopdata || []);

  const Handledata = (e) => {
    setDataCategory(prev => ({
      ...prev,
      [e.target.name]: e.target.value.split(".")
    }));
  };

  useEffect(() => {
    setAdditionalShopCategoryData(prev => ({
      ...prev,
      categoryid: categoryidone || "",
      subCategoryid: subcategoryitwo || "",
    }));
  }, [categoryidone, subcategoryitwo]);

  const Handleadditioanalshop = (e) => {
    setAdditionalShopCategoryData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const { data: mainCatRes } = useGetShopCategoriesQuery({ type: 'singleItem', parentCategory: '' });
  const [getSubCategories] = useLazyGetShopCategoriesQuery();
  const [getFilteredSingleScrapItem, { isLoading: isFilterLoading }] = useLazyGetFilteredSingleScrapItemQuery();

  // Fetch main categories
  useEffect(() => {
    if (mainCatRes?.success) {
      setShopCategory(mainCatRes.data.Category);
    }
  }, [mainCatRes]);

  // Fetch subcategories based on selected category
  const Mydata = () => {
    if (categoryName) {
      getSubCategories({ type: 'singleItem', parentCategory: categoryName })
        .unwrap()
        .then(res => {
          if (res?.success) setShopCategorytwo(res.data.Category);
        })
        .catch(err => console.log(err));
    }
  };

  // Filter items
  const FilterHandleritem = () => {
    const params = {
      itemname: additionalShopCategoryData?.itemname || "",
      categoryid: additionalShopCategoryData?.categoryid || "",
      subCategoryid: additionalShopCategoryData?.subCategoryid || "",
      country: additionalShopCategoryData?.country || "",
      state: additionalShopCategoryData?.state || "",
      city: additionalShopCategoryData?.city || "",
      salespromotion: additionalShopCategoryData?.salespromotion || "",
      min: additionalShopCategoryData?.min || "",
      max: additionalShopCategoryData?.max || "",
      isSingleItem: true,
    };

    // Filter out empty params cleanly
    const cleanedParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== "")
    );

    getFilteredSingleScrapItem(cleanedParams)
      .unwrap()
      .then(res => {
        if (res?.success || res?.data) {
          // Sometimes backend sends success: false when array is empty, handle carefully
          const items = res?.data || [];
          setShopdata(items);
          // Update context
          updateFilteredData(shopType, items, [], additionalShopCategoryData);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel showmodal={showmodal} handleClosemodal={handleClosemodal} handleShowshare={handleShowshare} />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="single-item-buy-mobile-back d-lg-none" />
        <Row className="single-item-buy-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                dataCategory={dataCategory}
                Handleadditioanalshop={Handleadditioanalshop}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                FilterHandleritem={FilterHandleritem}
                additionalShopCategoryData={additionalShopCategoryData}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius p-1 ps-2">
              <BackArrow back="/BuyingSide" mystyle="ps-1 d-none d-lg-block" />
              <UserItemShop shopdata={shopdata} isloading={isFilterLoading || isloading} />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SingleItemBuy;
